/**
 * System health endpoints.
 *
 * `/health/detailed` deliberately returns 503 when any provider check fails,
 * so we do not throw on non-2xx — the body is the report the operator
 * needs to see in both cases.
 */

import { fetchRawApi } from '../core';
import type { DetailedHealthResponse } from '../types';

export async function getDetailedHealth(): Promise<DetailedHealthResponse> {
  const response = await fetchRawApi(
    '/health/detailed',
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      requireAuth: false,
    },
    'system-health'
  );
  const body = (await response.json()) as DetailedHealthResponse;
  return body;
}
